import { render, staticRenderFns } from "./TermsPersonalThirdPartyKT.vue?vue&type=template&id=9062211e&scoped=true&"
var script = {}
import style0 from "./TermsPersonalThirdPartyKT.vue?vue&type=style&index=0&id=9062211e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9062211e",
  null
  
)

export default component.exports